import $ from 'jquery';
import lozad from 'C:\\Program Files (x86)\\Microsoft VS Code\\bin\\node_modules\\lozad';
import { isMobile, stripUrl } from './Utils';

class BackgroundController {
    constructor(elem) {
        this.elem = elem;
        this.target = elem.dataset.target;
        this.fullWidth = elem.dataset.full_width.toBoolean();
        this.fixBackground = elem.dataset.fix_background.toBoolean();
        this.useImageOnMobile = elem.dataset.use_image_on_mobile.toBoolean();
        this.imgUrl = elem.dataset.img;
        this.applyBackground();
    }

    applyBackground() {
        const bgImage = this.imgUrl;
        const webzoneWrapper = this.elem.closest('.webzone-wrapper');

        let backgroundWrapper = this.elem;
        switch (this.target) {
        case 'widget-zone':
            backgroundWrapper = this.elem.closest('.webzone-wrapper .row');
            break;
        case 'container':
            backgroundWrapper = webzoneWrapper;
            if (this.fullWidth) {
                $(webzoneWrapper).wrapInner(`<div class='${$(webzoneWrapper).attr('class')}'></div>`);
                $(webzoneWrapper).removeClass();
            }
            break;
        case 'page':
            // Apply background to html and body
            backgroundWrapper = document.querySelector('body>form');
            break;
        default:
            // do nothing
        }

        const bgColorElement = this.elem.querySelector('span[data-color]');
        if (bgColorElement !== undefined) {
            const bgColorCode = bgColorElement.dataset.color;
            if (bgColorCode !== 'none') {
                backgroundWrapper.classList.add('bg-color-wrapper');
                backgroundWrapper.classList.add('bg');
                backgroundWrapper.classList.add(`bg-${bgColorCode}`);
            }
        }
        if (bgImage.length > 0 && (this.useImageOnMobile || !isMobile())) {
            backgroundWrapper.classList.add('bg-lozad');
            backgroundWrapper.classList.add('bg-image-wrapper');
            backgroundWrapper.setAttribute('data-fix-background', this.fixBackground);
            backgroundWrapper.setAttribute('data-url', this.imgUrl);
            backgroundWrapper.setAttribute('data-gradient-color', bgColorElement.dataset.gradientColor);
            backgroundWrapper.setAttribute('data-gradient-strength', bgColorElement.dataset.gradientStrength);

            const observer = lozad('.bg-lozad', {
                loaded(el) {
                    const bgColorEl = el.querySelector('span[data-color]'); // need to get this again because of timing
                    const { gradientColor } = el.dataset;
                    const { gradientStrength } = el.dataset;
                    let { url } = el.dataset;
                    const { fixBackground } = el.dataset;

                    if (isMobile()) {
                        url = `${stripUrl(url)}?width=425`;
                    }

                    let bgCss = `url("${url}") no-repeat center center / cover`;

                    if (gradientColor && (gradientColor !== 'none') && gradientStrength && (gradientStrength !== 'none')) {
                        const bgColor = $(bgColorEl).getHexBackgroundColor();
                        const rgbaColor = `rgba(${parseInt(bgColor.substring(1, 3), 16)},${
                            parseInt(bgColor.substring(3, 5), 16)},${
                            parseInt(bgColor.substring(5, 7), 16)},${
                            gradientStrength})`;
                        bgCss = `linear-gradient(${rgbaColor}, ${rgbaColor}), ${bgCss}`;
                    }
                    else bgCss = `rgba(0, 0, 0, 0) ${bgCss}`;

                    el.style.background = bgCss;
                    if (fixBackground === 'true') {
                        el.style.backgroundAttachment = 'fixed';
                    }
                    el.classList.add('loaded');
                },
            });
            observer.observe();
        }
    }

    static init(container) {
        new BackgroundController(container); // eslint-disable-line no-new
    }
}

window.BackgroundController = BackgroundController;
export default BackgroundController;
